// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__GorS1","label":"Category_label__2GEr0","content":"Category_content__3jFEX","header":"Category_header__3-YhL","location":"Category_location__3Qv_0"};